import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../../library/components/Button";
import InputField from "../../../library/components/InputField";
import "./otp.css";
import { useParams } from "react-router-dom";
import backImage from "../../../images/back.png";
import PopUp_Screen from "../popup_screen";
import {
  useOtpsentMutation,
  useResendOtpMutation,
} from "../../../services/loginservices";
import { useDispatch } from "react-redux";
import { createAlert } from "../../../features/alert/alerts";
import { ALERT_TYPE_SUCCESS, USERTYPE } from "../../../constants/constants";
import ReactCountdownClock from "react-countdown-clock";

function OtpForm({
  otpObject,
  setOtpObject,
  setVerifyDisable,
  verifydisable,
  userId,
  setbuttonDisable,
}) {
  const dispatch = useDispatch();
  // const location = useLocation();
  const [sendOtp, dataS] = useResendOtpMutation();
  const [showOtpButton, setShowOtpButton] = useState(false);
  const [showOtpTimer, setShowOtpTimer] = useState(true);

  let navigate = useNavigate();
  const handleChange = (key, event) => {
    setVerifyDisable(false);
    setOtpObject({ ...otpObject, [key]: event });
  };
  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: "Success",
      })
    );
  };
  const myCallback = (e) => {
    setShowOtpTimer(false);
    setShowOtpButton(true);
  };

  const handleClick = (e) => {};
  const handleClickResendOtp = () => {
    setShowOtpTimer(true);
    setShowOtpButton(false);
    setVerifyDisable(false);
    var eciData = {
      applicationName: USERTYPE.ERONET,
      // password: "a",
      roleCode: "*",
      username: userId,
    };
    setOtpObject({
      ...otpObject,
      otp1: "",
      otp2: "",
      otp3: "",
      otp4: "",
      otp5: "",
      otp6: "",
    });
   
      sendOtp(eciData).then((res) => {
        onSuccess("OTP sent Successfully.");
      });
    
   
  };

  const inputfocus = (elmnt) => {
    if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
      const next = elmnt.target.tabIndex - 2;
      if (next > -1) {
        elmnt.target.form.elements[next].focus();
      }
    } else {
      const next = elmnt.target.tabIndex;
      if (next < 6) {
        elmnt.target.form.elements[next].focus();
      }
    }
  };

  // const login_timer = localStorage.getItem("login_time");

  // useEffect(() => {
  //   if (new Date().getTime() > Number(login_timer) + 1000 * 60 * 30) {
  //     window.location = "/login";
  //   }
  // }, [new Date().getTime()]);

  return (
    <>
      <div className="">
        <div className="col-sm-12 heading_login text-center">
          <h4 className="heading_login_title">Login</h4>
          <p className="heading_login_subtitle" style={{lineHeight:"normal"}}>Enter Details</p>
           <p className="heading_login_subtitle" style={{lineHeight:"normal"}}>To Get Sign In To Account
</p>
 <p className="heading_login_subtitle pt-2">{`Enter the OTP received on mobile number`}
</p>
          
        </div>
        <div className="row otp">
          <InputField
            name="otp1"
            type="text"
            inputClass="otpInput"
            onChange={(e) => handleChange("otp1", e)}
            tabIndex="1"
            maxLength="1"
            onKeyPress={() => {}}
            value={otpObject.otp1}
            onKeyUp={(e) => inputfocus(e)}
          />
          <InputField
            name="otp2"
            type="text"
            inputClass="otpInput"
            onChange={(e) => handleChange("otp2", e)}
            value={otpObject.otp2}
            tabIndex="2"
            maxLength="1"
            onKeyUp={(e) => inputfocus(e)}
          />
          <InputField
            name="otp3"
            type="text"
            inputClass="otpInput"
            onChange={(e) => handleChange("otp3", e)}
            value={otpObject.otp3}
            tabIndex="3"
            maxLength="1"
            onKeyUp={(e) => inputfocus(e)}
          />
          <InputField
            name="otp4"
            type="text"
            inputClass="otpInput"
            onChange={(e) => handleChange("otp4", e)}
            value={otpObject.otp4}
            tabIndex="4"
            maxLength="1"
            onKeyUp={(e) => inputfocus(e)}
          />
          <InputField
            name="otp5"
            type="text"
            inputClass="otpInput"
            onChange={(e) => handleChange("otp5", e)}
            value={otpObject.otp5}
            tabIndex="5"
            maxLength="1"
            onKeyUp={(e) => inputfocus(e)}
          />
          <InputField
            name="otp6"
            type="text"
            inputClass="otpInput"
            onChange={(e) => handleChange("otp6", e)}
            value={otpObject.otp6}
            tabIndex="6"
            maxLength="1"
            onKeyUp={(e) => inputfocus(e)}
          />
        </div>
        <Button
          btnClass="btn-block submit btnpurple"
          value="Verify OTP"
          onClick={handleClick}
          disabled={verifydisable}
          type="submit"
        />
        {showOtpButton && (
          <button
            className="btn btn-block submit btnpurple"
            value="Resend OTP"
            onClick={handleClickResendOtp}
            type="submit"
            style={{ height: "40px" }}
          >
            Resend OTP
          </button>
        )}

        {showOtpTimer && (
          <div
            className="row mt-2"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div className="mt-3">
              <h6>Resend OTP in :</h6>
            </div>
            <div className="ml-3 mb-3">
              <ReactCountdownClock
                seconds={180}
                color="green"
                alpha={0.9}
                size={50}
                showMilliseconds={false}
                onComplete={myCallback}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default OtpForm;

